<template>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 18 18"><path fill="currentColor" d="M1.929 8a1.25 1.25 0 1 0 0 2.5H7.75v5.821a1.25 1.25 0 0 0 2.5 0V10.5h5.821a1.25 1.25 0 1 0 0-2.5H10.25V2.179a1.25 1.25 0 0 0-2.5 0V8z"/></svg>
</template>